export default function FirstDeleteModal({ handleCloseDeleteModal, handleOpenSecondDeleteModal }) {

  return (
    <div className='fixed shadow-knowtex-shadow rounded-md w-[70%] h-[40%] top-[30%] right-[15%] z-10 bg-white flex flex-col gap-4 p-8 justify-center items-center'>
      <button className='absolute right-[20px] top-[10px] hover:text-ktx-navy font-bold text-[26px] z-[100]' onClick={handleCloseDeleteModal}>×</button>
      <h2 className="text-[28px] font-bold text-ktx-navy text-center">Are you sure you want to delete this doctor?</h2>
      <button onClick={() => handleOpenSecondDeleteModal()} className="bg-ktx-red hover:bg-red-700 text-white font-bold px-4 py-2 rounded-md w-[30%] mx-auto">Yes</button>
    </div>
  )
}